import { Box, BoxProps, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import { useState } from "react";
import { useTheme } from "../hooks";

interface SearchBarProps {
  onChange?: any;
  placeHolder: string;
  focused?: boolean;
  onFocus?: () => void;
}

const SearchBar = ({
  placeHolder,
  focused = false,
  onFocus = () => null,
  onChange = () => null,
  ...rest
}: SearchBarProps & BoxProps) => {
  const [autoFocus, setAutoFocus] = useState(focused);
  const { theme } = useTheme();

  const focusInput = () => {
    setAutoFocus(true);
  };

  return (
    <Box
      {...rest}
      sx={{ border: `solid 1px rgba(0, 0, 0, 0.23)`, borderRadius: 2 }}
    >
      <IconButton
        type="submit"
        aria-label="search"
        edge={false}
        sx={{
          backgroundColor: theme.color_primary,
          minWidth: "58px",
          borderRadius: 0,
          borderTopLeftRadius: 4,
          borderBottomLeftRadius: 4,
          ":hover": {
            backgroundColor: theme.color_primary,
            opacity: 0.7,
          },
        }}
        onClick={() => {
          onFocus();
          focusInput();
        }}
        data-testid="SearchIcon"
      >
        <SearchIcon style={{ fill: "white" }} />
      </IconButton>
      <TextField
        onInput={e => {}}
        onChange={onChange}
        variant="outlined"
        placeholder={placeHolder}
        size="medium"
        fullWidth
        autoFocus={autoFocus}
        focused={focused}
        onFocus={onFocus}
        sx={{
          "& fieldset": {
            border: "none",
          },
        }}
      />
    </Box>
  );
};

export default SearchBar;
